/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { connect } from 'react-redux'
import { SkipDisclosuresConnected } from '../components/modal/SkipDisclosures'

const Jumbotron = (props) => <SkipDisclosuresConnected {...props}>Skip</SkipDisclosuresConnected>

// eslint-disable-next-line import/prefer-default-export
export const SkipDisclosureButton = connect(null, null)(Jumbotron)
